// Vendor imports
const classNames = require('classnames')
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const { CapsuleButton } = require('client-v2/common/components/buttons')
const Icon = require('client-v2/common/containers/icons/component')
const PopperAnchor = require('client-v2/common/components/popper-anchor')
const tag = require('client-v2/common/utils/hyperscript')

const bem = BemEntity('AppSidebarFooter')

function AppSidebarFooter({ className }) {
  const [ isPopperActive, setPopperActive ] = React.useState(false)
  const togglePopper = React.useCallback(
    () => { setPopperActive(bool => !bool) },
    [ setPopperActive ]
  )
  const renderPopper = React.useCallback(
    popperProps => (
      tag('div', {
        ref: popperProps.ref,
        className: bem.element('popper'),
        style: popperProps.style
      },
        tag('a', {
          className: bem.element('popper-link'),
          href: '/terms'
        },
          'Terms of Service'
        ),
        tag('a', {
          className: bem.element('popper-link'),
          href: '/privacy'
        },
          'Privacy Policy'
        ),
        tag('hr', {
          className: bem.element('popper-rule')
        }),
        tag('span', {
          className: bem.element('popper-heading')
        },
          'Download'
        ),
        tag('a', {
          className: bem.element('popper-link'),
          href: '/sms-app'
        },
          'Mobile apps'
        ),
        tag('a', {
          className: bem.element('popper-link'),
          href: '/extensions'
        },
          'Browser extension'
        ),
        tag('hr', {
          className: bem.element('popper-rule')
        }),
        tag('a', {
          className: bem.element('popper-link', 'logout'),
          href: '/logout'
        },
          tag(Icon, { id: 'logout' }),
          'Log out'
        )
      )
    ),
    []
  )
  return (
    tag('footer', {
      className: classNames(
        className,
        bem.block()
      )
    },
      tag(CapsuleButton, {
        className: bem.element('settings'),
        href: '/settings'
      },
        tag(Icon, { id: 'gear' }),
        'Settings'
      ),
      tag(PopperAnchor, {
        isDisabled: !isPopperActive,
        placement: 'bottom-end',
        portalContainer: '#modal-root',
        renderPopper
      },
        tag(CapsuleButton, {
          'aria-label': 'More actions',
          className: bem.element('more', {
            active: isPopperActive
          }),
          onClick: togglePopper
        },
          tag(Icon, { id: 'next' })
        )
      )
    )
  )
}

module.exports = AppSidebarFooter
